module.exports = __webpack_public_path__ + "img/zwtp.3134c916.png";